import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { stage } from '../../index'
import {
  StyledWrapper,
  StyledPanelBottomText,
  StyledForm
} from './AuthStyles'
import { StyledInputField } from '../../common/components/Input'
import { StyledPrimaryButton } from '../../common/styledComponents/StyledButtons'
import { StyledNavigationLink } from '../../common/styledComponents/StyledLink'
import { StyledHeader2, StyledParagraph } from '../../common/styledComponents/StyledText'
import AuthDualPanel from './AuthDualPanel'
import Loader from '../../common/components/Loader'
import Visibility from '../../assets/images/visibility.svg'
import VisibilityOff from '../../assets/images/visibility_off.svg'
import { emailValidate } from '../../common/utils/validateInputs'

const INITIAL_STATE = {
  email: '',
  password: ''
}

const INITIAL_ERROR_STATE = {
  email: null,
  password: null
}

export const LoginForm = ({ onClick, serverError, isFetching }) => {
  const [values, setValues] = useState(INITIAL_STATE)
  const [errors, setError] = useState(INITIAL_ERROR_STATE)
  const [showPassword, setPassword] = useState(false)
  const [showServerError, setServerErrorVisibility] = useState(true)
  const handleInputChange = e => {
    setServerErrorVisibility(false)
    setError({ ...errors, [e.target.name]: null })
    setValues({ ...values, [e.target.name]: e.target.value })
  }

  const setPasswordVisibility = e => {
    e.preventDefault()
    setPassword(!showPassword)
  }

  const validateFields = () => {
    const email = (errors.email || !values.email) && (errors.email || 'Field is Required')
    const password = (errors.password || !values.password) && (errors.password || 'Field is Required')

    if (email || password) {
      setError(prev => ({
        ...prev,
        email,
        password
      }))

      return false
    }

    return true
  }

  const handleClick = e => {
    setServerErrorVisibility(true)
    if(validateFields()) {
      onClick(e, values)
    }
  }

  const updateFormError = errors => setError(prev => ({
    ...prev,
    ...errors
  }))

  const PasswordImage = showPassword ? Visibility : VisibilityOff

  return (
    <StyledForm noValidate>
      <StyledHeader2
        style={{ textAlign: 'center', marginBottom: '50px' }}
        className="heading"
      >
        Log In
      </StyledHeader2>
      <StyledInputField
        label="Email"
        name="email"
        type="email"
        input={{ type: 'email' }}
        overrideClassName="form-input login-email"
        value={values.email}
        onChange={handleInputChange}
        error={errors.email}
        validate={[emailValidate]}
        updateFormError={updateFormError}
        required
      />
      <StyledInputField
        label="Password"
        name="password"
        type={!showPassword && 'password'}
        overrideClassName="form-input"
        value={values.password}
        onChange={handleInputChange}
        error={errors.password}
        addon={<img src={PasswordImage} alt="input-img" />}
        onIconClick={setPasswordVisibility}
        updateFormError={updateFormError}
        triggerSubmit={handleClick}
        required
      />
      { isFetching && <Loader height='40px'/> }
      {showServerError && serverError && <StyledParagraph style={{ color: '#FF8A91', marginBottom: '10px' }}>{serverError}</StyledParagraph>}
      <StyledPrimaryButton type="button" onClick={handleClick} className="submit-btn">LOG IN</StyledPrimaryButton>
      <StyledNavigationLink
        to={'/reset-password'}
        className="form-info"
        color="#4DACA9"
        style={{ fontFamily: 'Lato', fontWeight: 'bold', width: 'unset', fontSize: '14px' }}
      >
        Forgot Password?
      </StyledNavigationLink>
      <StyledPanelBottomText className="mobile">
        {`Don't have an account?`}
        <StyledNavigationLink
          style={{ marginLeft: '10px', fontWeight: 'bold' }}
          color="#008575"
          to="/register"
        >
          Create Account
        </StyledNavigationLink>
      </StyledPanelBottomText>
    </StyledForm>
  )
}

LoginForm.defaultProps = {
  isFetching: false
}

LoginForm.propTypes = {
  onClick: PropTypes.func.isRequired,
  serverError: PropTypes.string,
  isFetching: PropTypes.bool
}

const Login = ({ onLoginClick, history, isFetching }) => {
  const [serverError, setServerError] = useState('')

  const handleClick = (e, values) => {
    e.preventDefault()
    setServerError('')
    const from = history.location.state ? history.location.state.from.pathname  : '/dashboard'
    const creds = { email: values.email.trim().toLowerCase(), password: values.password.trim() }
    if (stage==='demo') {
      setServerError('Customer access not permitted in Demo. Access through internal or go to www.customer.tracegenomics.com')
      return
    }
    return onLoginClick(creds).then((resp) => {
      if (resp.status === 429){
        setServerError('Too many login attempts, try again later!')

      } else if ( !resp.status || (resp.status !== 200 && resp.status !== 304) ) {
        if (resp.data && resp.data.message) {
          setServerError(resp.data.message)
        } else {
          setServerError('Login failed!')
        }
      } else {
        // route to details page if reg not complete, dashboard after successful login
        if (resp.data.user && !resp.data.user.verified_email){
          history.push(`/complete_registration/${resp.data.auth_token}`)
        } else {
          history.push(from)
        }
      }
    })
  }

  return (
    <StyledWrapper>
      <AuthDualPanel
        topTitle="REDISCOVER"
        title="YOUR SOIL"
        form={<LoginForm  onClick={handleClick}  serverError={serverError} isFetching={isFetching} />}
        bottomTextLink="register"
      />
    </StyledWrapper>
  )
}

Login.defaultProps = {
  isFetching: false
}

Login.propTypes = {
  onLoginClick: PropTypes.func.isRequired,
  history: PropTypes.object,
  isFetching: PropTypes.bool
}

export default Login
